import { EMPTY_OBJECT } from '../../../../../../constants/common'

import {
  MATCH_EDITOR_KIND,
  MATCH_EDITOR_KIND_BY_FIELD,
  MATCH_EDITOR_LIMITS_BY_FIELD,
} from './ApplicantFitCheckBlockRowEditor.constants'

export function getMatchEditorKind(criterion) {
  return MATCH_EDITOR_KIND_BY_FIELD[criterion.applicant_field] ?? null
}

export function getMatchEditorLimits(criterion) {
  return MATCH_EDITOR_LIMITS_BY_FIELD[criterion.applicant_field] ?? EMPTY_OBJECT
}

export function getIsMatchEditorDateKind(criterion) {
  return getMatchEditorKind(criterion) === MATCH_EDITOR_KIND.date
}

export function getHasMatchEditor(criterion) {
  return Boolean(getMatchEditorKind(criterion))
}
